export default __webpack_public_path__ + "static/media/apple-touch-icon-180x180.73d78c0b.png";